/**
*  料金シミュレーター
*
*  短期入所 & 短期入所（認知棟）
*
*  @since 2019.9.3
*  @use jQuery
*/



/**
*  Variables
*
*  自己負担となる利用金額
*/

//短期入所
const array_short = {
  // 所得段階 : [ 無, 第1段階, 第2段階, 第3段階 ]
  income : [ 1680, 300, 390, 650 ],

  /* 居住費 */
  // 多床室 : [ 無, 第1段階, 第2段階, 第3段階 ]
  multi  : {
    four : [ 408, 0, 370, 370 ],
    two  : [ 0, 0, 0, 0 ]
  },
  // 個室 : [ 無, 第1段階, 第2段階, 第3段階 ]
  single : [ 3760, 2520, 2520, 3340 ],

  /* 介護度に応じたサービス料 */
  kaigo :
  [
    { // 介護度 1 : [ 1割, 2割, 3割 ]
      multi  : {
        four : [ 1491, 2982, 4474 ],
        two  : [ 0, 0, 0, 0 ]
      },
      single : [ 1408, 2816, 4224 ]
    },
    { // 介護度 2 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1569, 3138, 4708 ],
          two  : [ 0, 0, 0, 0 ]
        },
      single : [ 1482, 2965, 4448 ]
    },
    { // 介護度 3 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1634, 3269, 4904 ],
          two  : [ 0, 0, 0, 0 ]
        },
      single : [ 1548, 3096, 4644 ]
    },
    { // 介護度 4 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1693, 3387, 5081 ],
          two  : [ 0, 0, 0, 0 ]
        },
      single : [ 1607, 3214, 4822 ]
    },
    { // 介護度 5 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1752, 3505, 5258 ],
          two  : [ 0, 0, 0, 0 ]
        },
      single : [ 1665, 3330, 4995 ]
    },
    { // 要支援 1 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1263, 2527, 3791 ],
          two  : [ 0, 0, 0, 0 ]
        },
      single : [ 1222, 2445, 3667 ]
    },
    { // 要支援 2 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1428, 2856, 4284 ],
          two  : [ 0, 0, 0, 0 ]
        },
      single : [ 1371, 2742, 4113 ]
    }
  ]
}

//短期入所（認知棟）
const array_shortSub = {
  // 所得段階 : [ 無, 第1段階, 第2段階, 第3段階 ]
  income : [ 1680, 300, 390, 650 ],

  /* 居住費 */
  // 多床室 : [ 無, 第1段階, 第2段階, 第3段階 ]
  multi  : {
    four : [ 408, 0, 370, 370 ],
    two  : [ 0, 0, 0, 0 ]
  },
  // 個室 : [ 無, 第1段階, 第2段階, 第3段階 ]
  single : [ 1730, 490, 490, 1310 ],

  /* 介護度に応じたサービス料 */
  kaigo :
  [
    { // 介護度 1 : [ 1割, 2割, 3割 ]
      multi  : {
        four : [ 1665, 3331, 4997 ],
        two  : [ 0, 0, 0, 0 ]
      },
      single : [ 1577, 3155, 4732 ]
    },
    { // 介護度 2 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1748, 3496, 5245 ],
          two  : [ 0, 0, 0, 0 ]
        },
      single : [ 1656, 3313, 4970 ]
    },
    { // 介護度 3 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1817, 3635, 5453 ],
          two  : [ 0, 0, 0, 0 ]
        },
      single : [ 1726, 3452, 5178 ]
    },
    { // 介護度 4 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1880, 3760, 5640 ],
          two  : [ 0, 0, 0, 0 ]
        },
      single : [ 1788, 3577, 5366 ]
    },
    { // 介護度 5 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1942, 3885, 5828 ],
          two  : [ 0, 0, 0, 0 ]
        },
      single : [ 1850, 3700, 5550 ]
    },
    { // 要支援 1 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1339, 2679, 4018 ],
          two  : [ 0, 0, 0, 0 ]
        },
      single : [ 1295, 2591, 3887 ]
    },
    { // 要支援 2 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1513, 3027, 4541 ],
          two  : [ 0, 0, 0, 0 ]
        },
      single : [ 1453, 2907, 4360 ]
    }
  ]
}




/**
*  function
*  動作
*/

// 短期入所
$( calcBtn.shortStay ).on('click', function(e){
  e.preventDefault();

  const formData = $( currentForm.shortStay ).serializeArray();
  const selectVal = selectCheck( currentForm.shortStay, formData );
  let roomExpense, serviceExpense;

  // すべて選択されていれば flag = true
  if( selectVal ){
    /* 計算処理開始 */
    // 部屋タイプに応じて居住費を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        roomExpense = array_short.multi.four[ selectVal.syotoku ];
      break;
      // 多床室（2人）
      case 2:
        roomExpense = array_short.multi.two[ selectVal.syotoku ];
      break;
      // 個室
      case 3:
        roomExpense = array_short.single[ selectVal.syotoku ];
      break;
      // default
      default:
        return;
      break;
    }

    // 部屋タイプと介護度に応じてサービス料を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        serviceExpense = array_short.kaigo[ selectVal.kaigo ].multi.four[ selectVal.futan ];
      break;
      // 多床室（2人）
      case 2:
        serviceExpense = array_short.kaigo[ selectVal.kaigo ].multi.two[ selectVal.futan ];
      break;
      // 個室
      case 3:
        serviceExpense = array_short.kaigo[ selectVal.kaigo ].single[ selectVal.futan ];
      break;
      // default
      default:
        return;
      break;
    }
    // 結果を出して表示する
    const result = ( array_short.income[ selectVal.syotoku ] + roomExpense + serviceExpense ) * parseInt( selectVal.days, 10 );
    $( resultElm.shortStay ).html( numberWithComma.format( result ) );
    $( resultElm.shortStayDays ).html( selectVal.days );
  } // end of 計算処理開始
return;
});



// 短期入所（認知棟）
$( calcBtn.shortStaySub ).on('click', function(e){
  e.preventDefault();

  const formData = $( currentForm.shortStaySub ).serializeArray();
  const selectVal = selectCheck( currentForm.shortStaySub, formData );
  let roomExpense, serviceExpense;

  // すべて選択されていれば flag = true
  if( selectVal ){
    /* 計算処理開始 */
    // 部屋タイプに応じて居住費を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        roomExpense = array_shortSub.multi.four[ selectVal.syotoku ];
      break;
      // 多床室（2人）
      case 2:
        roomExpense = array_shortSub.multi.two[ selectVal.syotoku ];
      break;
      // 個室
      case 3:
        roomExpense = array_shortSub.single[ selectVal.syotoku ];
      break;
      // default
      default:
        return;
      break;
    }

    // 部屋タイプと介護度に応じてサービス料を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        serviceExpense = array_shortSub.kaigo[ selectVal.kaigo ].multi.four[ selectVal.futan ];
      break;
      // 多床室（2人）
      case 2:
        serviceExpense = array_shortSub.kaigo[ selectVal.kaigo ].multi.two[ selectVal.futan ];
      break;
      // 個室
      case 3:
        serviceExpense = array_shortSub.kaigo[ selectVal.kaigo ].single[ selectVal.futan ];
      break;
      // default
      default:
        return;
      break;
    }

    // 結果を出して表示する

    const result = ( array_shortSub.income[ selectVal.syotoku ] + roomExpense + serviceExpense ) * parseInt( selectVal.days, 10 );
    $( resultElm.shortStaySub ).html( numberWithComma.format( result ) );
    $( resultElm.shortStaySubDays ).html( selectVal.days );
  } // end of 計算処理開始

return;

});
